export default __webpack_public_path__ + "static/media/bouton_360.f30e79a6.svg";